import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfessionsListComponent } from './professions-list/professions-list.component';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { ProfessionFormComponent } from './profession-form/profession-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ProfessionsListComponent,
    ProfessionFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    SharedModule,
    ReactiveFormsModule,
  ]
})
export class ProfessionsModule { }
